import {Box, Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	height: 100%;
	justify-content: center;
	align-items: center;
`;

const Grid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	row-gap: 40px;
	column-gap: 24px;

	${({theme}) => theme.breakpoints.down('md')} {
		row-gap: 16px;
		grid-template-columns: 1fr;
	}
`;

export {Grid, StyledContainer};
